import { render, staticRenderFns } from "./DialogColorPerspective.vue?vue&type=template&id=1361f726&scoped=true&"
import script from "./DialogColorPerspective.vue?vue&type=script&lang=js&"
export * from "./DialogColorPerspective.vue?vue&type=script&lang=js&"
import style0 from "./DialogColorPerspective.vue?vue&type=style&index=0&id=1361f726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1361f726",
  null
  
)

export default component.exports